import { ReactNode } from 'react';
import classnames from 'classnames';

const className = classnames(
  'border-b',
  'border-menu-border-color',
  'bg-menu-background-color',
  'text-menu-link-color',
  'flex',
  'flex-col',
  'justify-center',
  'lg:border-b-0',
  'lg:w-36',
  'lg:border-r',
  'lg:border-menu-border-color',
  'lg:flex',
  'lg:flex-none',
  'lg:justify-start',
  'lg:grow'
);

interface Props {
  children: ReactNode;
}

const Menu = ({ children }: Props) => (
  <header className={className}>{children}</header>
);

export default Menu;
